import { EntranceLock } from './entrance-lock';
import { Location } from './location';
import { Reward } from './reward';
var Dungeon = /** @class */ (function () {
    function Dungeon(_location, _dungeonAbbr, _dungeonName, _bossName, _reward, _maxItemChests, _maxTotalChests, _maxSmallKeys, _entranceLock) {
        if (_entranceLock === void 0) { _entranceLock = EntranceLock.None; }
        this._location = _location;
        this._dungeonAbbr = _dungeonAbbr;
        this._dungeonName = _dungeonName;
        this._bossName = _bossName;
        this._reward = _reward;
        this._maxItemChests = _maxItemChests;
        this._maxTotalChests = _maxTotalChests;
        this._maxSmallKeys = _maxSmallKeys;
        this._entranceLock = _entranceLock;
        this._itemChestCount = this._maxItemChests;
        this._totalChestCount = this._maxTotalChests;
        this._bossId = this._location;
        this._isBossDefeated = false;
        this._hasBigKey = false;
        this._smallKeyCount = 0;
        this._retroChestCount = this._maxItemChests + this._maxSmallKeys;
    }
    Object.defineProperty(Dungeon.prototype, "location", {
        get: function () {
            return this._location;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dungeon.prototype, "dungeonAbbr", {
        get: function () {
            return this._dungeonAbbr;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dungeon.prototype, "dungeonName", {
        get: function () {
            return this._dungeonName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dungeon.prototype, "bossName", {
        get: function () {
            return this._bossName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dungeon.prototype, "maxItemChests", {
        get: function () {
            return this._maxItemChests;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dungeon.prototype, "itemChestCount", {
        get: function () {
            return this._itemChestCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dungeon.prototype, "maxTotalChests", {
        get: function () {
            return this._maxTotalChests;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dungeon.prototype, "maxRetroChests", {
        get: function () {
            return this.maxItemChests + this.maxSmallKeys;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dungeon.prototype, "totalChestCount", {
        get: function () {
            return this._totalChestCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dungeon.prototype, "retroChestCount", {
        get: function () {
            return this._retroChestCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dungeon.prototype, "maxSmallKeys", {
        get: function () {
            return this._maxSmallKeys;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dungeon.prototype, "smallKeyCount", {
        get: function () {
            return this._smallKeyCount;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dungeon.prototype, "hasSmallKeys", {
        get: function () {
            return this.maxSmallKeys > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dungeon.prototype, "hasBigKey", {
        get: function () {
            return this._hasBigKey;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dungeon.prototype, "bossId", {
        get: function () {
            return this._bossId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dungeon.prototype, "entranceLock", {
        get: function () {
            return this._entranceLock;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dungeon.prototype, "medallionName", {
        get: function () {
            return EntranceLock[this.entranceLock].toLowerCase();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dungeon.prototype, "isBossDefeated", {
        get: function () {
            return this._isBossDefeated;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dungeon.prototype, "reward", {
        get: function () {
            return this._reward;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dungeon.prototype, "hasDungeonEndingReward", {
        get: function () {
            return this.reward !== Reward.None;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dungeon.prototype, "hasMedallionEntrance", {
        get: function () {
            return this.entranceLock !== EntranceLock.None;
        },
        enumerable: true,
        configurable: true
    });
    Dungeon.prototype.decrementItemChestCount = function () {
        this._itemChestCount = (this.itemChestCount === 0) ? this.maxItemChests : this.itemChestCount - 1;
    };
    Dungeon.prototype.decrementTotalChestCount = function () {
        this._totalChestCount = (this.totalChestCount === 0) ? this.maxTotalChests : this.totalChestCount - 1;
    };
    Dungeon.prototype.decrementRetroChestCount = function () {
        this._retroChestCount = (this.retroChestCount === 0) ? this.maxRetroChests : this.retroChestCount - 1;
    };
    Dungeon.prototype.incrementSmallKeyCount = function () {
        this._smallKeyCount = (this.smallKeyCount === this.maxSmallKeys) ? 0 : this.smallKeyCount + 1;
    };
    Dungeon.prototype.cycleEntranceLock = function () {
        switch (this.entranceLock) {
            case EntranceLock.Unknown:
                this._entranceLock = EntranceLock.Bombos;
                break;
            case EntranceLock.Bombos:
                this._entranceLock = EntranceLock.Ether;
                break;
            case EntranceLock.Ether:
                this._entranceLock = EntranceLock.Quake;
                break;
            case EntranceLock.Quake:
                this._entranceLock = EntranceLock.Unknown;
                break;
            default:
                break;
        }
    };
    Dungeon.prototype.cycleReward = function () {
        switch (this.reward) {
            case Reward.Unknown:
                this._reward = Reward.GreenPendant;
                break;
            case Reward.GreenPendant:
                this._reward = Reward.StandardPendant;
                break;
            case Reward.StandardPendant:
                this._reward = Reward.StandardCrystal;
                break;
            case Reward.StandardCrystal:
                this._reward = Reward.FairyCrystal;
                break;
            case Reward.FairyCrystal:
                this._reward = Reward.Unknown;
                break;
        }
    };
    Dungeon.prototype.toggleDefeat = function () {
        this._isBossDefeated = !this.isBossDefeated;
    };
    Dungeon.prototype.toggleBigKey = function () {
        this._hasBigKey = !this._hasBigKey;
    };
    Dungeon.prototype.cycleBossForward = function () {
        if (!this.hasDungeonEndingReward) {
            return;
        }
        var number = this.bossId + 1;
        if (number === Location.GanonsTower) {
            number = Location.EasternPalace;
        }
        this._bossId = number;
    };
    Dungeon.prototype.cycleBossBackward = function () {
        if (!this.hasDungeonEndingReward) {
            return;
        }
        var number = this.bossId - 1;
        if (number === Location.CastleTower) {
            number = Location.TurtleRock;
        }
        this._bossId = number;
    };
    Dungeon.prototype.reset = function () {
        this._itemChestCount = this.maxItemChests;
        this._totalChestCount = this.maxTotalChests;
        this._smallKeyCount = 0;
        this._isBossDefeated = false;
        this._bossId = this._location;
        this._hasBigKey = false;
        if (this._reward !== Reward.None) {
            this._reward = Reward.Unknown;
        }
        if (this.entranceLock !== EntranceLock.None) {
            this._entranceLock = EntranceLock.Unknown;
        }
    };
    return Dungeon;
}());
export { Dungeon };
